import { InputProps } from "antd";
import { StyledPassword } from "./atom";

export function Password({ className = "", ...props }: InputProps) {
  return (
    <StyledPassword className={`renderbus-ui--input ${className}`} {...props} />
  );
}
